import { FormContent, Wrapper } from '@maxtropy/components';
import { Button, Col, Form, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { selectTemplateColumns } from '../utils';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { getTenantDistributionTemplateSearch, TenantDistributionTemplateRes } from '../../../api/edgeTemplate';

const routes = [{ name: 'Iot配置' }, { name: '数采配置' }, { name: '模板分配' }, { name: '数采模板分配详情' }];

const formLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 18 },
};

const TemplateDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [info, setInfo] = useState<TenantDistributionTemplateRes>();

  useEffect(() => {
    if (id) {
      getTenantDistributionTemplateSearch(id).then(data => {
        setInfo(data);
      });
    }
  }, [id]);

  return (
    <Wrapper routes={routes} {...formLayout}>
      <FormContent title="租户信息">
        <Form layout="vertical">
          <Row>
            <Col span={12}>
              <Form.Item label="租户code">
                <span>{info?.code ?? '--'}</span>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="租户名称">
                <span>{info?.name ?? '--'}</span>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </FormContent>
      <FormContent title="数采模板">
        <Table
          columns={selectTemplateColumns}
          dataSource={info?.templateList ?? []}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100'],
            showTotal: () => `共${info?.templateList.length ?? 0}条`,
          }}
        />
        <Button style={{ marginTop: 20 }} onClick={() => navigate(`/device/edge/distribution${search}`)}>
          返回
        </Button>
      </FormContent>
    </Wrapper>
  );
};

export default TemplateDetail;
